module.exports = __webpack_public_path__ + "static/media/snapscope-1.00c98a07.jpg";